import React,{useState,useEffect} from 'react'
import {Row,Col} from 'react-bootstrap'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { optionsShowtt, optionsStatus, optionsdept } from '../../Helper'

import ReactPaginate from 'react-paginate'
import PillSmall from '../../subComponents/CustomSubComponents/PillSmall'
import { hrManageCandidateApi } from '../../../utils/AdminDashApi/HRmanageCandidateApi'
import MobileInputSubComp from './sub_components/MobileInputSubComp'
const HRManageCandidatesCompmb = () => {
    const [show,setShow] = useState(10)
    const drpfuncshow=(myshow,id)=>{
        setShow(myshow)        
      }
      const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(hrManageCandidateApi.data)
  const [tempfilteredarr,settempfilteredarr] = useState([])
  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  

  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    setitemsPerPagefiltered(show?show:10)
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr,show]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % hrManageCandidateApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
      const [role,setrole]= useState("")
      const [labelrole,setlabelrole]= useState("")
      const [borderrole,setborderrole]= useState("")
      const [department,setdepartment]= useState("")
      const [labeldepartment,setlabeldepartment]= useState("")
      const [borderdepartment,setborderdepartment]= useState("")
      const [employeeType,setemployeeType]= useState("")
      const [labelemployeeType,setlabelemployeeType]= useState("")
      const [borderemployeeType,setborderemployeeType]= useState("")

      const drpfuncrole=(myval,myid)=>{
        setrole(myval)
      }
      const drpfuncdept=(myval,myid)=>{
        setdepartment(myval)
      }
      const drpfuncEmpType=(myval,myid)=>{
        setemployeeType(myval)
      }
     
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Job Management</h3>
                </div>
                <div className="admbwrap">
                    <Row>
                    <MobileInputSubComp col="6" name="Role" direct="left"><               div className="dropdownwrapper" >
                        
                        <Dropdown2 err={borderrole} func={drpfuncrole} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                    </div>
                    <label>{labelrole}</label>
                    </MobileInputSubComp>
                    <MobileInputSubComp col="6" name="Department" direct="right"><               div className="dropdownwrapper" >
                    <div className="dropdownwrapper" >
                              
                              <Dropdown2 err={borderdepartment} func={drpfuncdept} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsdept}/>
                          </div>
                          <label>{labeldepartment}</label>
                          </div>
                    </MobileInputSubComp>
                    <MobileInputSubComp col="6" name="Employee Type" direct="left"><               div className="dropdownwrapper" >
                    <div className="dropdownwrapper">
                                    
                                    <Dropdown2 err={borderemployeeType} func={drpfuncEmpType} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>                                
                                <label>{labelemployeeType}</label>
                                </div>
                    </MobileInputSubComp>

                    </Row>

                    
                </div>
                <div className="admbwrap pb0">
                <Row>

                <MobileInputSubComp col="4" name="Show" direct="left">
                    <div className="dropdownwrapper">
                    <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowtt}/>
                    </div>
                </MobileInputSubComp>
                <MobileInputSubComp col="8" name="Search" direct="right">
                <div className="wrap">
                    <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                    <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                    </div>
                </MobileInputSubComp>

                </Row>
                </div>
                <div className="admbwrap pr0">
                    <div className="tablewrapscroll">
                    <div className="flexvaluetable bigtable3000 hrshiftsetuptablediv ">
                    <table>
                      <thead>
                        <tr>
                            {
                              hrManageCandidateApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.candidateName}</td>
                                  <td>{item.mobilenumber}</td>
                                  <td>{item.email}</td>
                                  <td>{item.presentaddress}</td>
                                  <td>{item.permanentaddress}</td>
                                  <td>{item.role}</td>
                                  <td>{item.department}</td>
                                  <td>{item.level}</td>
                                  <td>{item.salaryExp}</td>
                                  <td>{item.employementType}</td>
                                  <td>{item.experience}</td>
                                  <td className='text-center'>
                                    <img style={{width:"16px"}} src={item.action} alt="" />
                                  </td>
                                  
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                        </div>
                        </div>
                        <div className="admbwrap">
                <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={2}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {hrManageCandidateApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default HRManageCandidatesCompmb